import { useSelector } from 'react-redux';
import authCompany from 'store/selectors/authCompany';
import { hasCompanyFeature } from 'utils/companyFeatureFlags';

export function useCompanyFeature(name) {
  const company = useSelector(authCompany);
  return hasCompanyFeature(company?.featureFlags, name);
}
